import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Checkbox
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import DatePicker from "react-datepicker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";

import DateTimePicker from "react-datetime-picker";
import "../../../style/react-datetimepicker.scss";
let rand = require("random-key");

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {};

let offerTitle = [],
  expirationMonth = [],
  expirationDate = [],
  minQuantity = [],
  skuCode = [],
  maxPerCustomer = [],
  maxAvailable = [],
  retailPrice = [],
  offerPrice = [],
  remittance = [],
  incrementalRedemption = [],
  maxAsGift = [];

class DealAttribute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      isInfinite: 0
    };
  }

  componentDidMount() {}

  isInfinite = e => {
    if (e.target.checked) {
      this.setState({ isInfinite: 0 });
      this.props.updateChildDeals(
        e.target.name,
        0,
        this.props.index
      );
    } else {
      this.setState({ isInfinite: 1 });
      this.props.updateChildDeals(
        e.target.name,
        1,
        this.props.index
      );
    }
  };

  componentWillMount() {
    const result1 = this.props.deal.startDateTime && this.props.deal.startDateTime.substring(0,10)
    const result2 = this.props.deal.expiryDateTime && this.props.deal.expiryDateTime.substring(0,10)
    this.setState({
      startDateTime: (this.props.deal.startDateTime != null && result1 != '1970-01-01' && this.props.deal.startDateTime != '')
        ? new Date(moment(this.props.deal.startDateTime).format("YYYY-MM-DDTHH:mm"))
        : "",
      expiryDateTime: (this.props.deal.expiryDateTime != null && result2 != '1970-01-01' && this.props.deal.expiryDateTime != '')
        ? new Date(moment(this.props.deal.expiryDateTime).format("YYYY-MM-DDTHH:mm"))
        : "",
      dealText: this.props.deal.dealText,
      fontSize: this.props.deal.fontSize,
      voucherText: this.props.deal.voucherText,
      isInfinite: this.props.deal.isInfinite
    });
  }

  handleChange = e => {
    this.props.updateChildDeals(
      e.target.name,
      e.target.value,
      this.props.index
    );
    this.setState({ [e.target.name]: e.target.value });
  };

  componentWillReceiveProps(nextProps) {}

  onChangeStartDate = date => {
    this.setState({ startDateTime: date });
    this.props.updateChildDeals(
      "startDateTime",
      moment(date).format(),
      this.props.index
    );
  };

  onChangeExpiryDate = date => {
    this.setState({ expiryDateTime: date });
    this.props.updateChildDeals(
      "expiryDateTime",
      moment(date).format(),
      this.props.index
    );
  };

  render() {
    let isInfiniteChecked = this.props.deal.isInfinite == "0" ? "true" : "false";
    return (
      <div key={this.props.index}>
        <Col md={12} xs={12}>
          <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <Row className="bg-success">
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Retail Price</h5>
                </ControlLabel>
                <h3>${this.props.deal.retailPrice}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Offer Price</h5>
                </ControlLabel>
                <h3>${this.props.deal.offerPrice}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Maximum Available</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxAvailable}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Max Per Customer</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxPerCustomer}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Max As Gift</h5>
                </ControlLabel>
                <h3>{this.props.deal.maxAsGift}</h3>
              </Col>
              <Col md={2} xs={6} className="text-center">
                <ControlLabel>
                  <h5>Expiration</h5>
                </ControlLabel>
                <h3>{this.props.deal.expiryDateTime}</h3>
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={12} xs={12}>
          &nbsp;
        </Col>
        <Col md={12} xs={12}>
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>Duration</ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col md={3} xs={6}>
              {this.state.startDateTimeTooltipError && (
                <Tooltip placement="top" className="in" id="tooltip-top">
                  {this.state.startDateTimeTooltipError}
                </Tooltip>
              )}
              <DateTimePicker
                className={this.state.startDateTimeError}
                onChange={this.onChangeStartDate}
                value={this.state.startDateTime}
              />
            </Col>
            <Col md={1} xs={12}>
              <FormGroup controlId="formOfferTitle">
                <ControlLabel>until</ControlLabel>
              </FormGroup>
            </Col>
            <Col md={3} xs={6}>
              {this.state.expiryDateTimeTooltipError && (
                <Tooltip placement="top" className="in" id="tooltip-top">
                  {this.state.expiryDateTimeTooltipError}
                </Tooltip>
              )}
              <DateTimePicker
                onChange={this.onChangeExpiryDate}
                value={this.state.expiryDateTime}
              />
            </Col>
            <Col md={3} xs={12}>
              <FormGroup controlId="formInfinitely">
                {(this.props.deal.isInfinite == "0") ?
                <Checkbox
                  name="isInfinite"
                  defaultChecked={true}
                  onChange={this.isInfinite}
                >
                  Run this offer infinitely?
                </Checkbox>
                :
                <Checkbox
                  name="isInfinite"
                  onChange={this.isInfinite}
                >
                  Run this offer infinitely?
                </Checkbox>
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
        
        <Col md={12} xs={12}>
          <Row>
            <Col md={12} xs={12}>
              <ControlLabel>
                Deal/Offer Text (Text that appears on the site,
                up to 75 characters)
              </ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <FormControl
                  type="text"
                  defaultValue={this.state.dealText}
                  placeholder="Deal Text"
                  onBlur={this.handleChange}
                  name="dealText"
                />
                <p className="inline-validation-error">
                  {this.state.dealTextError !== ""
                    ? this.state.offerTitleError
                    : " "}
                </p>
              </FormGroup>
            </Col>
            {/*<Col md={1} xs={1} className="text-center">
              <FormGroup controlId="formAt">
                <ControlLabel>at</ControlLabel>
              </FormGroup>
            </Col>
            <Col md={2} xs={2}>
              <FormGroup>
                <FormControl
                  type="text"
                  defaultValue={this.state.fontSize}
                  placeholder="Font Size"
                  onBlur={this.handleChange}
                  name="fontSize"
                />
                <p className="inline-validation-error">
                  {this.state.fontSizeError !== ""
                    ? this.state.offerTitleError
                    : " "}
                </p>
              </FormGroup>
            </Col>
            <Col md={2} xs={2}>
              <FormGroup controlId="formPixels">
                <ControlLabel>pixels</ControlLabel>
              </FormGroup>
            </Col>*/}
          </Row>

          <Row>
            <Col md={12} xs={12}>
              <FormGroup>
                <ControlLabel>
                  Voucher Text (Text that appears on the voucher)
                </ControlLabel>
                <FormControl
                  type="text"
                  defaultValue={this.state.voucherText}
                  placeholder="Voucher Text"
                  onBlur={this.handleChange}
                  name="voucherText"
                />
                <p className="inline-validation-error">
                  {this.state.voucherTextError !== ""
                    ? this.state.voucherTextError
                    : " "}
                </p>
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default DealAttribute;



// WEBPACK FOOTER //
// ./src/app/views/admin/deal/DealAttribute.js